"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var modal_1 = require("ngx-bootstrap/modal");
var core_2 = require("@ngx-translate/core");
var toaster_logger_service_1 = require("../../../../core/toaster-logger.service");
var VinCueModalComponent = /** @class */ (function () {
    function VinCueModalComponent(_bsModalRef, tService, logger, dealSheetService) {
        this._bsModalRef = _bsModalRef;
        this.tService = tService;
        this.logger = logger;
        this.dealSheetService = dealSheetService;
        this.hasLatestAppraisal = false;
        this.usersList = [];
        this.selectedSalespersonId = -1;
        this.selectedAppraiserId = -1;
        this.onSaveChanges = new core_1.EventEmitter();
    }
    VinCueModalComponent.prototype.ngOnInit = function () {
        var _this = this;
        this._bsModalRef.hide();
        this.getLatestAppraisal(this.dealerId, this.vehicle.vin);
        if (this.vehicle.estimatedCurrentMileage) {
            this.estimatedMileage = this.vehicle.estimatedCurrentMileage;
        }
        else {
            this.estimatedMileage = null;
        }
        if (this.customer.cellPhoneNumber) {
            this.primaryPhone = this.customer.cellPhoneNumber.value;
        }
        else if (this.customer.homePhoneNumber) {
            this.primaryPhone = this.customer.homePhoneNumber.value;
        }
        else {
            this.primaryPhone = null;
        }
        this.getCustomerAddress();
        this.getFullTrim();
        this.buildUsersList();
        if (this.userId > 0) {
            var user = this.usersList.find(function (x) { return x.id === Number(_this.userId); });
            if (user) {
                this.selectedSalespersonId = this.userId;
            }
        }
    };
    VinCueModalComponent.prototype.ngAfterViewInit = function () {
        this._bsModalRef.hide();
    };
    VinCueModalComponent.prototype.cancelModal = function () {
        this._bsModalRef.hide();
    };
    VinCueModalComponent.prototype.sendAppraisal = function () {
        var _this = this;
        var salesPerson;
        var appraiser;
        if (this.selectedSalespersonId) {
            var user = this.usersList.find(function (x) { return x.id === Number(_this.selectedSalespersonId); });
            if (user) {
                salesPerson = { firstName: user.firstName, lastName: user.lastName, email: user.email };
            }
        }
        if (this.selectedAppraiserId) {
            var user = this.usersList.find(function (x) { return x.id === Number(_this.selectedAppraiserId); });
            if (user) {
                appraiser = { firstName: user.firstName, lastName: user.lastName, email: user.email };
            }
        }
        var result = { salesPerson: salesPerson, appraiser: appraiser };
        this.onSaveChanges.emit(result);
        this._bsModalRef.hide();
    };
    VinCueModalComponent.prototype.getLatestAppraisal = function (dealerId, vin) {
        var _this = this;
        return this.dealSheetService.getLatestAppraisalVinCue(dealerId, vin)
            .then(function (data) {
            if (data && data.appraisal) {
                _this.hasLatestAppraisal = true;
                _this.appraisalId = data.appraisal.id;
                _this.deepLink = data.deepLink;
                _this.createDate = data.appraisal.created;
                _this.acv = data.appraisal.acv;
            }
            else {
                _this.hasLatestAppraisal = false;
            }
        });
    };
    VinCueModalComponent.prototype.getCustomerAddress = function () {
        var address1 = '';
        var address2 = '';
        if (this.customer) {
            if (this.customer.address.streetAddress)
                address1 = this.customer.address.streetAddress;
            else
                address1 = '';
            if (this.customer.address.streetAddress2)
                address2 = ' ' + this.customer.address.streetAddress2;
            else
                address2 = ' ';
            this.fullAddress = address1 + address2 + ', ' + this.customer.address.city + ', ' + this.customer.address.stateName + ', ' + this.customer.address.normalizedZipCode;
        }
    };
    VinCueModalComponent.prototype.getFullTrim = function () {
        this.fullTrim = this.vehicle.yearID + " " + this.vehicle.makeName + " " + this.vehicle.trimFullName;
    };
    VinCueModalComponent.prototype.buildUsersList = function () {
        for (var i = 0; i < this.users.length; i++) {
            //Must create a new array and not reference the binding
            //as it can change the parent array. filter and add only user's with type id 1 that is client
            if (this.users[i].userTypeId == 1)
                this.usersList.push(this.users[i]);
        }
        // sort it to ascending order by fullName
        this.usersList.sort(this.dynamicSort("fullName"));
    };
    VinCueModalComponent.prototype.dynamicSort = function (property) {
        var sortOrder = 1;
        if (property[0] === "-") {
            sortOrder = -1;
            property = property.substr(1);
        }
        return function (a, b) {
            var result = (a[property] < b[property]) ? -1 : (a[property] > b[property]) ? 1 : 0;
            return result * sortOrder;
        };
    };
    return VinCueModalComponent;
}());
exports.VinCueModalComponent = VinCueModalComponent;
